<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="950">
            <v-card>
                <v-card-title>
                    {{ $t("new_mileage_reading") }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="fetchAllLookups({cache: false})">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-menu
                        offset-y
                        v-if="!!form.lines.length">
                        <template v-slot:activator="{on}">
                            <v-btn
                                icon
                                v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item
                                link
                                v-if="!!form.lines.length"
                                @click="deleteMileageReadingLines()">
                                <v-list-item-avatar>
                                    <v-icon>mdi-delete</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-title>{{ $t("delete_all") }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-form
                            v-model="valid"
                            ref="form">
                            <v-row>
                                <v-col cols="3">
                                    <v-menu
                                        ref="datePicker"
                                        v-model="datePicker"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px">

                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="form.date"
                                                :label="$t('date')"
                                                append-icon="mdi-calendar"
                                                v-bind="attrs"
                                                v-on="on"
                                                readonly
                                                :rules="rules.date"
                                                :loading="loading.mileageReading"
                                                :disabled="loading.mileageReading">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="form.date" no-title @input="datePicker = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="3">
                                    <v-select
                                        :label="$t('truck_type')"
                                        :items="truckTypes"
                                        v-model="form.truck_type_id"
                                        item-text="name"
                                        item-value="id"
                                        @change="fetchTrackableTrucks()"
                                        :disabled="!!form.lines.length || loading.data || loading.mileageReading"
                                        :loading="loading.truckTypes || loading.mileageReading">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-skeleton-loader
                                type="table"
                                v-if="loading.mileageReading">
                            </v-skeleton-loader>
                            <v-data-table
                                v-if="!loading.mileageReading"
                                dense
                                :headers="headers.mileageReadings"
                                :items="form.lines"
                                :loading="loading.data"
                                disable-pagination
                                hide-default-footer
                                disable-sort>
                                <template v-slot:[`item.distance`]="{item}">
                                    <v-text-field
                                        class="my-1"
                                        dense
                                        hide-details
                                        v-model="item.distance"
                                        :rules="rules.distance">
                                    </v-text-field>
                                </template>
                                <template v-slot:[`item.remarks`]="{item}">
                                    <v-text-field
                                        class="my-1"
                                        dense
                                        hide-details
                                        v-model="item.remarks">
                                    </v-text-field>
                                </template>
                            </v-data-table>
                        </v-form>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        :disabled="!valid || form.lines.length == 0 || loading.submit"
                        :loading="loading.submit"
                        @click="submit">
                        {{ $t("save") }}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close"
                        >
                        {{ $t("cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import fetchLookups from '../utils/fetchLookups';
import AlertDialog from '../components/AlertDialog';
export default {
    name: "MileageReadingDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            datePicker: false,
            display: false,
            valid: false,
            openParams: null,
            loading: {
                data: false,
                submit: false,
                truckTypes: false,
                mileageReading: false
            },
            mode: {
                edit: false
            },
            form: {
                date: null,
                truck_type_id: null,
                lines: []
            },
            rules: {
                date: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                distance: [
                    v => !!v || this.$t("required"),
                    v => !isNaN(v) || this.$t("required")
                ]
            },
            headers: {
                mileageReadings: [
                    { text: this.$t("plate_number"), value: "plate_number" },
                    { text: this.$t("truck_type"), value: "truck_type" },
                    { text: this.$t('distance_km'), value: "distance"},
                    { text: this.$t("remarks"), value: "remarks"}
                ]
            }
        }
    },
    computed: {
        ...mapState("truckType", ["truckTypes"])
    },
    methods: {
        fetchLookups,
        ...mapActions("truck", ["fetchTrucksWithTrackableDistance"]),
        ...mapActions("truckType", ["fetchTruckTypes"]),
        ...mapActions("mileageReading", ["storeMileageReading", "fetchMileageReading", "updateMileageReading"]),
        open({editMode, id}) {
            this.mode.edit = editMode;
            this.openParams = {id};
            this.display = true;
            this.openDataFetch();
        },
        async openDataFetch() {
            if(this.mode.edit) this.fetchRecordForEdit();
            this.fetchAllLookups({cached: true});
        },
        fetchAllLookups({cached}) {
            this.fetchLookups([
                {target: "truckTypes", action: this.fetchTruckTypes(), cached}
            ]);
        },
        fetchRecordForEdit() {
            this.loading.mileageReading = true;
            this.fetchMileageReading(this.openParams.id)
                .then((response) => {
                    this.loading.mileageReading = false;
                    this.form = response.data;
                })
                .catch(error => {
                    this.close();
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.alertDialog.open(this.$t("ALERT_TITLE_WARNING"), message);
                });
        },
        async fetchTrackableTrucks() {
            try {
                this.loading.data = true;
                this.trackableTrucks, this.lines = [];
                this.loading.data = true;
                let trackableTrucks = await this.fetchTrucksWithTrackableDistance(this.form.truck_type_id);
                trackableTrucks = trackableTrucks.data;
                this.form.lines = trackableTrucks;
                this.loading.data = false;
            } catch(error) {
                let message = null;
                message = error.response ? error.response.message : error;
                this.$refs.alertDialog(this.$t("error_title"), message);
            }
        },
        close() {
            this.display = false
            this.form.lines = [];
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeMileageReading(this.form)
                    .then(() => {
                        this.loading.submit = false;
                        this.close();
                        this.$emit("submit");
                        this.$refs.alertDialog.open(this.$t("ALERT_TITLE_WARNING"), this.$t("RECORD_SAVE_SUCCESS"));
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            } else {
                this.updateMileageReading(this.form)
                    .then(() => {
                        this.loading.submit = false;
                        this.close();
                        this.$emit("submit");
                        this.$refs.alertDialog.open(this.$t("ALERT_TITLE_WARNING"), this.$t("RECORD_SAVE_SUCCESS"));
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), message);
                    });
            }
        },
        openMileageReadingLinesDialog() {
            this.$refs.mileageReadingLinesDialog.open();
        },
        fillMileageReadingLines(params) {
            this.form.lines = params;
        },
        deleteMileageReadingLines() {
            this.form.lines = [];
            this.form.truck_type_id = null;
        }
    }
}
</script>